import { render, staticRenderFns } from "./long-term-goals-select.vue?vue&type=template&id=1a2e9532"
import script from "./long-term-goals-select.vue?vue&type=script&lang=js"
export * from "./long-term-goals-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports